import fileMethods from '@/helpers/fileMethods';
import documentsService from '@/services/DocumentsService';
import { uploadFile } from '@/services/FileUploadService';
import store from '@/store';
import axios from 'axios';

const DEVICE_KEYS = [
  'air_conditioning',
  'battery_storage',
  'heat_pump',
  'wallbox',
];

export const initCDFiles = async (consumptionDeviceOrder) => {
  const promises = [];

  store.commit('setConsumptionDeviceFilesInitialized', false);
  store.commit('resetConsumptionDevicesUploadFilesModule');

  const devices = consumptionDeviceOrder?.controllable_devices;
  if (!devices) return;

  for (const key of DEVICE_KEYS) {
    const deviceGroup = devices[key];
    if (!deviceGroup) continue;

    // Iterate over all UUIDs inside each device type (wallbox, heat_pump, etc.)
    for (const uuid in deviceGroup) {
      const device = deviceGroup[uuid];

      // Handle standard picture files for all devices
      if (device?.picture?.picture_name && device?.picture?.picture_id) {
        promises.push(
          getConsumptionDeviceDocument(
            device.picture.picture_name,
            key, // device type
            device.picture.picture_id,
            consumptionDeviceOrder.id
          )
        );
      }

      // Handle additional unit_certificate file for battery_storage
      if (
        key === 'battery_storage' &&
        device?.unit_certificate?.file_name &&
        device?.unit_certificate?.file_id
      ) {
        promises.push(
          getConsumptionDeviceDocument(
            device.unit_certificate.file_name,
            key,
            device.unit_certificate.file_id,
            consumptionDeviceOrder.id
          )
        );
      }
    }
  }
  await Promise.all(promises);
  store.commit('setConsumptionDeviceFilesInitialized', true);
};

export const getConsumptionDeviceDocument = async (
  fileName,
  fileKey,
  pictureId,
  orderId
) => {
  if (!fileName || !pictureId) return;

  const s3Path = `${orderId}/${pictureId}/${fileName}`;
  const bucket = `netzportal-consumption-device-${process.env.VUE_APP_STAGE}`;

  await documentsService
    .getDocumentFromS3(s3Path, bucket)
    .then(async (res) => {
      await downloadFromPresignedURL(
        res.downloadFile,
        fileName,
        fileKey,
        pictureId
      );
    })
    .catch((err) => {
      console.error(`❌ Error downloading file for ${fileKey}:`, err);
      console.error(`❌ Failed S3 path:`, s3Path);
    });
};

export const downloadFromPresignedURL = async (
  fileURL,
  fileName,
  fileKey,
  pictureId
) => {
  const downloadResponse = await axios({
    url: fileURL,
    method: 'GET',
    headers: {
      Accept: '*',
      'Content-Type': 'application/pdf;charset=utf-8',
    },
    responseType: 'arraybuffer',
  });

  const product = 'ConsumptionDeviceFiles';
  const id = `${pictureId}`;
  const fileObject = fileMethods.convertToBlobAndReturnFileObject(
    downloadResponse.data,
    fileName,
    product,
    id,
    fileKey
  );

  store.commit('setConsumptionDeviceFileURL', fileObject);
};

export const uploadCDFiles = async (selectedFiles) => {
  const fileNames = [];
  const filesForUpload = [];
  selectedFiles.forEach((fileObject) => {
    if (fileObject.file_name) {
      fileNames.push(`${fileObject.file_id}/${fileObject.file_name}`);
      filesForUpload.push(fileObject);
      const fileURL = { url: '', imageName: fileObject.file_name };
      fileURL.url = window.URL.createObjectURL(fileObject.file);
      store.commit('setConsumptionDeviceFileURL', fileURL);
    }
  });

  const PromiseArr = [];
  for (let i = 0; i < fileNames.length; i++) {
    const file_name = `${store.getters.getSelectedConsumptionDevice.id}/${fileNames[i]}`;
    PromiseArr.push(
      fileMethods.uploadFileGraphQL(
        file_name,
        `netzportal-consumption-device-${process.env.VUE_APP_STAGE}`
      )
    );
  }

  const signedUrls = await Promise.all(PromiseArr).then((res) => {
    return res;
  });

  try {
    const fileUploadsPromises = [];
    let i = 0;
    for (const signedUrl of signedUrls) {
      fileUploadsPromises.push(uploadFile(signedUrl, filesForUpload[i].file));
      i++;
    }

    return Promise.all(fileUploadsPromises).catch((e) => {
      console.error(e);
      console.error(`Could not upload files ${fileNames}`);
      throw e;
    });
  } catch (e) {
    console.error(e);
    console.error(`Could not upload files ${fileNames}`);
  }
};
